export class FuelBid {
    gsmId: string;
    name: string;
    email:string;
    phone: string;
    product : string;
    quantity:number;
    quantityGallons: number;
    dateRequired : string;
    location: string;
    message:string;

    /**
     *
     */
    // constructor() {
    //     this.gsmId = '';
    //     this.name = '';
    //     this.email = '';
    //     this.phone = '';
    //     this.product = '';
    //     this.dateRequired = '';
    //     this.location = '';
    //     this.message = '';
    //     this.quantity= 0;
    //     this.quantityGallons = 0;
    // }
}